module.exports = __webpack_public_path__ + "static/media/IMAGENDEINICIO.00fc7cf5.png";